(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup() {
    document.querySelectorAll('[data-ev-text]').forEach(function (t) {
      if (t.dataset.evReady) return;
      t.dataset.evReady = '1';
      var btn = t.parentNode.querySelector('[data-ev-more]');
      t.classList.add('is-clamped');
      if (t.scrollHeight - t.clientHeight > 4 && btn) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var open = t.classList.toggle('is-clamped') === false;
          btn.textContent = open ? 'Show less' : 'Read more';
        });
      } else {
        t.classList.remove('is-clamped');
      }
    });
  }
  function weekly() {
    var M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var MF = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var D = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var DF = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var now = new Date();
    document.querySelectorAll('[data-ev-weekly]').forEach(function (row) {
      var days = (parseInt(row.dataset.evWeekly, 10) - now.getDay() + 7) % 7;
      var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
      row.querySelector('[data-ev-mon]').textContent = M[d.getMonth()];
      row.querySelector('[data-ev-day]').textContent = d.getDate();
      row.querySelector('[data-ev-dow]').textContent = days === 0 ? 'Today' : D[d.getDay()];
      row.querySelector('[data-ev-next]').textContent = days === 0 ? 'Today' : 'Next one: ' + DF[d.getDay()] + ', ' + MF[d.getMonth()] + ' ' + d.getDate();
    });
  }
  function init() { weekly(); setup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function start(box) {
    var slides = box.querySelectorAll('.hero__slide');
    if (slides.length < 2 || box.dataset.started) return;
    box.dataset.started = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var i = 0, paused = false, wait = parseInt(box.dataset.interval, 10) || 6000;
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      var next = slides[(i + 1) % slides.length];
      if (next.loading === 'lazy') next.loading = 'eager';
      if (!next.complete) return;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, wait);
    setTimeout(function () { slides.forEach(function (s) { s.loading = 'eager'; }); }, 1500);
  }
  function init() { document.querySelectorAll('[data-hero-slides]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = '1';
    var dlg = root.querySelector('[data-pg-lightbox]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var img = dlg.querySelector('[data-lb-img]');
    var cap = dlg.querySelector('[data-lb-cap]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-open]'));
    var idx = 0;
    function show(i) {
      idx = (i + items.length) % items.length;
      var it = items[idx];
      img.src = it.dataset.src;
      img.alt = it.dataset.caption || '';
      cap.textContent = it.dataset.caption || '';
      dlg.querySelectorAll('.pg-lightbox__nav').forEach(function (b) { b.hidden = items.length < 2; });
    }
    items.forEach(function (btn, i) {
      btn.addEventListener('click', function () { show(i); dlg.showModal(); });
    });
    dlg.querySelector('[data-lb-close]').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('[data-lb-prev]').addEventListener('click', function () { show(idx - 1); });
    dlg.querySelector('[data-lb-next]').addEventListener('click', function () { show(idx + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    var sx = null;
    dlg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
    });
  }
  function init() { document.querySelectorAll('[data-gallery]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-photo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function draw(crew) {
    var svg = crew.querySelector('[data-crew-arrows]');
    var photo = crew.querySelector('[data-crew-photo]');
    if (!svg || !photo || getComputedStyle(svg).display === 'none') return;
    var box = crew.getBoundingClientRect();
    var p = photo.getBoundingClientRect();
    // Keep blurbs on the same side from bumping into each other (longer blurbs need more room)
    ['left', 'right'].forEach(function (side) {
      var col = crew.querySelector('.crew__side--' + side);
      if (!col) return;
      var c = col.getBoundingClientRect();
      var notes = Array.prototype.slice.call(col.querySelectorAll('[data-crew-note]'));
      notes.sort(function (a, b) { return parseFloat(a.dataset.y) - parseFloat(b.dataset.y); });
      var prevBottom = c.top - 16, last = c.bottom;
      notes.forEach(function (n) {
        n.style.top = n.dataset.y + '%';
        var r = n.getBoundingClientRect();
        var shift = Math.max(0, prevBottom + 20 - r.top);
        if (shift) n.style.top = 'calc(' + n.dataset.y + '% + ' + shift + 'px)';
        prevBottom = r.bottom + shift;
        last = Math.max(last, prevBottom);
      });
      col.dataset.overflow = Math.ceil(last - c.bottom);
    });
    var over = Math.max.apply(null, Array.prototype.map.call(crew.querySelectorAll('.crew__side'), function (c) { return +c.dataset.overflow || 0; }));
    crew.style.paddingBottom = over > 0 ? over + 'px' : '';
    box = crew.getBoundingClientRect();
    p = photo.getBoundingClientRect();
    svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);
    var out = '';
    crew.querySelectorAll('[data-crew-note]').forEach(function (note, i) {
      var r = note.getBoundingClientRect();
      var left = note.classList.contains('crew__note--left');
      var name = note.querySelector('.crew__name');
      var nr = (name || note).getBoundingClientRect();
      var sx = (left ? r.right + 10 : r.left - 10) - box.left;
      var sy = nr.top + nr.height / 2 - box.top;
      var ex = p.left - box.left + p.width * parseFloat(note.dataset.x) / 100;
      var ey = p.top - box.top + p.height * parseFloat(note.dataset.y) / 100;
      var dx = ex - sx;
      var lift = (i % 2 ? 1 : -1) * Math.min(40, Math.abs(dx) * 0.25);
      var c1x = sx + dx * 0.35, c1y = sy + lift;
      var c2x = sx + dx * 0.75, c2y = ey + lift * 0.6;
      out += '<path d="M' + sx + ' ' + sy + ' C' + c1x + ' ' + c1y + ' ' + c2x + ' ' + c2y + ' ' + ex + ' ' + ey + '"/>';
      var ang = Math.atan2(ey - c2y, ex - c2x), len = 11, spread = 0.45;
      var ax = ex - len * Math.cos(ang - spread), ay = ey - len * Math.sin(ang - spread);
      var bx = ex - len * Math.cos(ang + spread), by = ey - len * Math.sin(ang + spread);
      out += '<path d="M' + ax + ' ' + ay + ' L' + ex + ' ' + ey + ' L' + bx + ' ' + by + '"/>';
    });
    svg.innerHTML = '<g class="halo">' + out + '</g><g>' + out + '</g>';
  }
  function init() {
    document.querySelectorAll('[data-crew]').forEach(function (crew) {
      draw(crew);
      var img = crew.querySelector('[data-crew-photo] img');
      if (img && !img.complete) img.addEventListener('load', function () { draw(crew); });
      if (window.ResizeObserver) new ResizeObserver(function () { draw(crew); }).observe(crew);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();

  } catch(e) { console.error(e); }
})();
})();
